import Vue from 'vue';

export default {
  path: '/profile',
  component: () => import('@/views/Profile/ProfilePage.vue'),
  beforeEnter: (to, from, next: any, ) => {
    if (Vue.prototype.$auth && Vue.prototype.$auth.currentUser) {
      next();
    } else {
      console.error("Not authenticated");
      next({ name: 'home' });
    }
  },
  children: [
    {
      path: '',
      component: () => import(/* webpackChunkName: "profile.account" */ '@/views/Profile/Account/Account.vue'),
      meta: { title: 'Account | Taiko' }
    },
    {
      path: 'account',
      name: 'profile.account',
      component: () => import(/* webpackChunkName: "profile.account" */ '@/views/Profile/Account/Account.vue'),
      meta: { title: 'Account | Taiko' }
    },
    {
      path: 'artworks',
      name: 'profile.artworks',
      component: () => import(/* webpackChunkName: "profile.artworks" */ '@/views/Profile/Artworks/Artworks.vue'),
      meta: { title: 'Profile artworks | Taiko' }
    },
    {
      path: 'artworks/draft',
      name: 'profile.artworks.draft',
      component: () => import(/* webpackChunkName: "profile.artworks" */ '@/views/Profile/Artworks/DraftArtworks.vue'),
      meta: { title: 'Draft artworks | Taiko' }
    },
    {
      path: 'artworks/edit/:artworkId?',
      alias: 'artworks/edit/:artworkId?/test/default',
      name: 'profile.artworks.edit',
      component: () => import(/* webpackChunkName: "profile.artworks.edit" */ '@/views/Profile/Artworks/Edit/ProfileArtworkEditPage.vue'),
      props: true
    },

    {
      path: 'sales',
      name: 'profile.sales',
      component: () => import(/* webpackChunkName: "profile.sales" */ '@/views/Profile/Sales.vue'),
      meta: { title: 'Sales | Taiko' }
    },
    {
      path: 'favorites',
      name: 'profile.favorites',
      component: () => import(/* webpackChunkName: "profile.favorites" */ '@/views/Profile/Favorites.vue'),
      meta: { title: 'Favorites | Taiko' }
    },
    {
      path: 'subscriptions',
      name: 'profile.subscriptions',
      component: () => import(/* webpackChunkName: "profile.favorites" */ '@/views/Profile/ProfileSubscriptionListPage.vue'),
      meta: { title: 'Subscriptions | Taiko' }
    },
    {
      path: 'purchases',
      name: 'profile.purchases',
      component: () => import(/* webpackChunkName: "profile.artworks" */ '@/views/Profile/Purchases.vue'),
      meta: { title: 'Purchases | Taiko' }
    },
    {
      path: 'practical-information',
      name: 'profile.pracitcal-information',
      component: () => import(/* webpackChunkName: "profile.practical" */ '@/views/Profile/PracticalInfo.vue'),
      meta: { title: 'Practical information | Taiko' }
    }
  ]
}
